import { apiClient } from "../config";

async function editRole(id: any, data: any) {
  const url = `/admin/roles/${id}`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editRole;
